/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

class PasswordForm extends React.Component {
  props: {
    onSave: Function,
  };

  state = {
    enabled: false,
  };

  submit = (attrs: Object) => {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.props.onSave();
    };

    const onFailure = (error) => ToastActions.showAPIError(error);

    UserActions
      .createPassword(attrs.password)
      .then(onSuccess, onFailure);
  };

  render() {
    return (
      <div className="PasswordForm">
        <Form
          onValidSubmit={this.submit}
          onValid={() => this.setState({ enabled: true })}
          onInvalid={() => this.setState({ enabled: false })}>
          <FormInput
            type="password"
            autoComplete="new-password"
            className="PasswordForm-password"
            name="password"
            placeholder="Password"
            required
            validations="minLength:6"
            validOnPristine
            validationError="Password must be at least 6 characters long."
          />
          <Button
            disabled={!this.state.enabled}
            className="PasswordForm-Submit"
            type="submit"
            eventElementName="PasswordForm-Submit">
            {'Save'}
          </Button>
        </Form>
      </div>
    );
  }
}

export default PasswordForm;



// WEBPACK FOOTER //
// ./src/components/PasswordForm.jsx